import { forwardRef } from 'react'
import { TouchableOpacity } from 'react-native'

import {
  B1,
  B2,
  B5,
  Icon,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'

interface Props {
  label?: string
  onChange: (...props: any) => void
  onBlur: (...props: any) => void
  isRequired?: boolean
  fieldOptions: { optionValue: string; optionId: any; icon?: string }[]
  value: any
  errorMessage?: string
}

export const Toggle: React.FC<Props> = forwardRef(
  (
    { label, onChange, onBlur, value, errorMessage, isRequired, fieldOptions },
    ref
  ) => {
    return (
      <Stack>
        <XStack>
          {!!label && <B2 className="text-grays-80 mb-1">{label}</B2>}
          {isRequired && <B1 className="text-error-100 pl-1">*</B1>}
        </XStack>
        <XStack>
          {fieldOptions?.map((item) => (
            <TouchableOpacity
              onPress={() => {
                onChange(item?.optionId)
                onBlur()
              }}
              key={item?.id}
            >
              <XStack
                className={`mr-3 items-center rounded-xl border px-3 py-2
                    ${
                      value !== item?.optionId
                        ? 'border-grays-40'
                        : 'border-primary-100 bg-grays-20'
                    }             
            `}
              >
                {!!item?.icon && (
                  <Icon
                    color={`${
                      value !== item.optionId
                        ? '#596379'
                        : zetColors.primary[100]
                    }`}
                    type={item.icon}
                    size={36}
                    className="mr-1"
                  />
                )}

                <B2 className="text-grays-80">{item.optionValue}</B2>
              </XStack>
            </TouchableOpacity>
          ))}
        </XStack>
        {!!errorMessage && <B5 className="text-error-100">{errorMessage}</B5>}
      </Stack>
    )
  }
)
